function configPass(config){
    return "/web/wx/check"==config.url||"/web/customer/customersave"==config.url||"/web/product/productlist"==config.url||"/web/type/typelist"==config.url
      ||"/web/news/newsdetail"==config.url||"/web/sms/sms"==config.url||"/app/login"==config.url
      ||"/web/order/addsearch"==config.url||"/web/company/search"==config.url||"/web/order/ordersave"==config.url||"/web/order/ordersave2"==config.url
      ||"/web/wxpick/ticket"==config.url||"/web/pick/customer"==config.url||"/web/order/orderdetail"==config.url;
}
  
  
  export {configPass}
  